var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("b", [_vm._v(_vm._s(_vm.message.text))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userData.name,
              expression: "userData.name"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          staticClass: "form-control",
          class: { "form-alert": _vm.errors.has("name") },
          attrs: { name: "name", type: "text", placeholder: "ชื่อ-สกุล" },
          domProps: { value: _vm.userData.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.userData, "name", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("name"),
                expression: "errors.has('name')"
              }
            ],
            staticClass: "help text-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("name")))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userData.tel,
              expression: "userData.tel"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          staticClass: "form-control",
          class: { "form-alert": _vm.errors.has("name") },
          attrs: { name: "tel", type: "text", placeholder: "เบอร์โทร" },
          domProps: { value: _vm.userData.tel },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.userData, "tel", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("tel"),
                expression: "errors.has('tel')"
              }
            ],
            staticClass: "help text-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("tel")))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userData.email,
              expression: "userData.email"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "'required|email'"
            }
          ],
          staticClass: "form-control",
          class: { "form-alert": _vm.errors.has("name") },
          attrs: { name: "email", type: "text", placeholder: "อีเมล" },
          domProps: { value: _vm.userData.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.userData, "email", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("email"),
                expression: "errors.has('email')"
              }
            ],
            staticClass: "help text-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("email")))]
        )
      ]),
      _vm._v(" "),
      !_vm.saveSuccess
        ? _c("div", { staticClass: "form-group" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-block btn-info",
                attrs: { disabled: _vm.loading },
                on: {
                  click: function($event) {
                    return _vm.checkEmailAccount()
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.isRegistering) + "\n      ")]
            )
          ])
        : _c("div", { staticClass: "text-center mt-4" }, [_vm._m(0)]),
      _vm._v(" "),
      _vm.receivedCredits
        ? _c("div", { staticClass: "text-center mt-4" }, [
            _c("hr"),
            _vm._v(" "),
            _c("div", [
              _c("i", { staticClass: "fas fa-coins -icon-coins" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "message.invite_friends.earned_coins_from_friend_invitation"
                    )
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm._f("currency")(_vm.receivedCredits)))
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("i", { staticClass: "fas fa-check-circle -status-accepted" }),
      _vm._v(" ลงทะเบียนสำเร็จ\n      ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f06fd6e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f06fd6e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/RegisterMessage.vue
// module id = 2116
// module chunks = 0